import {
  createAsyncThunk,
  createSelector,
  createSlice,
} from "@reduxjs/toolkit";
import { HttpClient } from "../../../api/httpClient";
import { DEFAULT_ENTITY_STATE } from "../../utils";

const baseName = "audit";

const initialState = DEFAULT_ENTITY_STATE;

export const getAudit = createAsyncThunk(`${baseName}/getAudit`, async () => {
  const res = await HttpClient.get({
    url: "/smartAudit",
  });
  return res?.data;
});

export const auditSlice = createSlice({
  name: baseName,
  initialState,
  reducers: {
    setupAudit(state, { payload }) {
      const { data } = payload || {};
      //CONFIGURAR ENTRADA DE DADOS
      state.data = data?.map((item) => ({ ...item, id: item?._id })) || [];
    },

    //ADM ACTIONS
    addAudit(state, { payload }) {
      state.data.unshift(payload);
    },
    updateAudit(state, { payload }) {
      const { id, changes } = payload;
      const index = state.data.findIndex((item) => item.id === id);
      if (index !== -1) {
        state.data[index] = {
          ...state.data[index],
          ...changes,
        };
      }
    },
    removeAudit(state, { payload }) {
      state.data = [...state.data?.filter((item) => item?.id !== payload)];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAudit.pending, (state, action) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(getAudit.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message || null;
      })
      .addCase(getAudit.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.error = null;

        //Dados API
        const data = action.payload || [];
        auditSlice.caseReducers.setupAudit(state, {
          payload: {
            data,
          },
        });
      });
  },
});

export const { addAudit, removeAudit, setupAudit, updateAudit } =
  auditSlice.actions;

export default auditSlice.reducer;

export const selectAuditState = createSelector(
  [(state) => state.audit],
  (auditState = {}) => {
    const prevData = auditState || DEFAULT_ENTITY_STATE;
    return {
      ...prevData,
      total: prevData?.data?.length || 0,
    };
  }
);

export const selectAuditById = createSelector(
  [selectAuditState, (state, auditId) => auditId],
  (auditState = {}, auditId = "") => {
    return auditState?.data?.find((item) => item?.id === auditId) || {};
  }
);
